<div
  class="sz-segmented"
  [class.sz-segmented--mono]="mono()"
  [class.sz-segmented--disabled]="disabled()"
  role="tablist">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="sz-segmented__seg"
      [class.is-active]="option.value === value()"
      [disabled]="disabled()"
      role="tab"
      [attr.aria-selected]="option.value === value()"
      (click)="select(option.value)">
      {{ option.label }}
    </button>
  }
</div>
